<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="workTypeCategoryGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
      >
        <template v-slot:buttons>
          <WorkTypeCategoryModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_work_type',
              })
            "
            :create="true"
          />
        </template>
        <WorkTypeCategoryTable :workTypeCategoryGrid="workTypeCategoryGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import WorkTypeCategoryTable from 'components/setting/workTypeCategory/WorkTypeCategoryTable'
import WorkTypeCategoryModal from 'components/setting/workTypeCategory/WorkTypeCategoryModal'

export default {
  name: 'settingWorkTypesCategory',
  components: {
    WorkTypeCategoryTable,
    WorkTypeCategoryModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workTypeCategory', ['workTypeCategoryGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workTypeCategory', ['onWorkTypeCategoryGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkTypeCategoryGrid(data)
    },
  },
}
</script>
